import PatientTasks from '../common/PatientTasks';

interface PatientTasksTabProps {
  detailsTabId?: string;
  familyTaskCount?: number;
  maudTaskCount?: number;
  patientId: string;
  selectedTaskTab?: number;
  setSelectedTaskTab?: (selectedTaskTab: number) => void;
}

 // TODO: GX-3701 - Remove PatientTasksTab wrapper once old routing + PatientTabsMap are retired
const PatientTasksTab = ({
  detailsTabId,
  familyTaskCount,
  maudTaskCount,
  patientId,
  selectedTaskTab,
  setSelectedTaskTab,
}: PatientTasksTabProps) => (
  <PatientTasks
    detailsTabId={detailsTabId}
    familyTaskCount={familyTaskCount}
    maudTaskCount={maudTaskCount}
    patientId={patientId}
    selectedTaskTab={selectedTaskTab}
    setSelectedTaskTab={setSelectedTaskTab}
  />
);

export default PatientTasksTab;
